module.exports = __webpack_public_path__ + "img/depmap_svg_V94.718b28d7.svg";